export default "__VITE_ASSET__0yvpRDCe__"